export * from './[id]';
